import INJECTION_KEYS from '@injectionKeys'
import { computed, inject } from 'vue'

export const useSchoolYears = () => {
    /** @type {GlobalState} */
    const globalState = inject(INJECTION_KEYS.GLOBALSTATE)

    const schoolYears = computed(() => globalState?.baseData?.schoolYears || [] )

    const sortedSchoolYears = computed(() => {
        const schoolYearsWithoutSuccessor = schoolYears.value.filter(item => !item.uuidSuccessor)

        const sorted = []

        schoolYearsWithoutSuccessor.forEach(schoolYearWithoutSuccessor => {
            let current = schoolYearWithoutSuccessor
            while (current) {
                sorted.push(current)
                current = schoolYears.value.find(item => current.uuid === item.uuidSuccessor)
            }
        })

        return sorted
    })

    return { schoolYears, sortedSchoolYears }
}

